import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-choose-ticket',
  templateUrl: './choose-ticket.component.html',
  styleUrls: ['./choose-ticket.component.css']
})
export class ChooseTicketComponent implements OnInit {
  

  constructor() { }

  ngOnInit(): void {
  }

}
